import React, { useState, useEffect } from 'react';
import {
  useParams,
  useNavigate
} from 'react-router-dom';

function Authorizer(props) {

  const urlParameters = useParams();
  const history = useNavigate();

  const [authorized, setAuthorized] = useState(false);

  useEffect(function onLoad() {

    initialize();

    return function uninitialize() {
      setAuthorized(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initialize() {

    const result = await props.if();

    if (result === true) {
      props.then(history, urlParameters);
    } else {
      props.else(history);
    }

    setAuthorized(true);

  }

  function renderChildren() {

    if (authorized === false) {
      return <React.Fragment />;
    }

    return React.cloneElement(props.children, { ...urlParameters });

  }

  return renderChildren();

}

export default Authorizer;